import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from "@angular/forms";

import {FormFieldHiddenComponent} from "@app/_modules/form-fields/types/hidden/form-field-hidden.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  declarations: [
    FormFieldHiddenComponent
  ],
  exports: [
    FormFieldHiddenComponent
  ]
})
export class FormFieldHiddenModule {}
